export default "__VITE_ASSET__23ead22e__"